module.exports = __webpack_public_path__ + "img/23.765fa240.png";